import { GenericAbortSignal } from 'axios';

import http from 'services/http';

// The portal registry (OLIO-3072): which portal source systems exist and what to call
// them. `systemName` is the identifier on the wire — the `source_system` value on
// workflows, scripts, and settings; `displayName` is what we render for it. Served by
// olio-api from its portal_systems table, so adding a portal is a data change there,
// not a code change here.
export interface PortalSystemOption {
  id: string;
  systemName: string;
  displayName: string;
}

export const portalSystemQueryKeys = {
  base: ['portalSystems'] as const,
};

export async function indexPortalSystems(signal?: GenericAbortSignal) {
  return http.get<{ data: PortalSystemOption[] }>('portal_systems', { signal }).then((res) => res.data.data);
}
